import React from 'react';
import { whyChooseUs } from '../data/mockData';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';
import * as Icons from 'lucide-react';

const WhyChooseUsSection = ({ onOpenContactForm }) => {
  return (
    <section className="relative py-20 bg-gradient-to-br from-[#1a1a2e] via-gray-900 to-[#1a1a2e] overflow-hidden">
      {/* Diagonal Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#FF9900]/5 to-transparent" style={{ clipPath: 'polygon(0 10%, 100% 0, 100% 90%, 0 100%)' }}></div>
      
      {/* Decorative Elements */}
      <div className="absolute top-20 right-20 w-96 h-96 bg-blue-500 rounded-full opacity-5 blur-3xl"></div>

      <div className="container mx-auto px-4 relative z-10">
        {/* Heading */}
        <div className="text-center max-w-4xl mx-auto mb-16">
          <div className="inline-block bg-gradient-to-r from-[#FF9900]/20 to-orange-600/20 border border-[#FF9900]/30 text-[#FF9900] px-4 py-2 rounded-full text-sm font-semibold mb-4">
            Why Choose Us
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            Leading Trademark Registration Services in the US
          </h2>
          <p className="text-xl text-gray-300 leading-relaxed">
            Professional trademark attorneys providing online trademark registration, federal trademark filing, USPTO trademark application support, trademark search services, copyright registration, LLC formation, company registration, and Amazon Brand Registry enrollment. Trust our expert trademark legal services to protect your brand identity nationwide.
          </p>
        </div>

        {/* 3 USPs */}
        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {whyChooseUs.map((usp, index) => {
            const IconComponent = Icons[usp.icon];
            return (
              <div
                key={usp.id}
                className="bg-gradient-to-br from-gray-800/50 to-gray-900/50 backdrop-blur-sm rounded-3xl p-8 shadow-2xl hover:shadow-[#FF9900]/20 transition-all duration-300 transform hover:-translate-y-2 border border-white/10 hover:border-[#FF9900]/30"
                style={{
                  animationDelay: `${index * 100}ms`
                }}
              >
                <div className="w-16 h-16 bg-gradient-to-r from-[#FF9900] to-orange-600 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                  {IconComponent && <IconComponent className="w-8 h-8 text-black" />}
                </div>
                <h3 className="text-2xl font-bold text-white mb-4">{usp.title}</h3>
                <p className="text-gray-300 leading-relaxed">{usp.description}</p>
              </div>
            );
          })}
        </div>

        {/* Button */}
        <div className="text-center">
          <Button
            onClick={onOpenContactForm}
            size="lg"
            className="bg-gradient-to-r from-[#FF9900] to-orange-600 hover:from-[#FF9900]/90 hover:to-orange-600/90 text-black px-8 py-6 text-lg font-semibold shadow-lg"
          >
            Start Your Registration Today
            <ArrowRight className="ml-2 w-5 h-5" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;